import { IDR } from '@/libs/currency'
import { defaultThClass, defaultThStyle } from '../../config'

const defaultClass = {
  tdClass: '!font-[400] text-[#333333]',
  class: `${defaultThClass} !text-[14px] !text-[#333333]`,
}

/**
 * @description - Konfigurasi options untuk filter status tagihan
 * @returns {Array} - Array of options
 * @example
 * [
 *   { value: 'all', text: 'Semua Status' },
 *   { value: 'PENDING', text: 'Belum Dibayar' },
 *   { value: 'PAID', text: 'Sudah Dibayar' },
 * ]
 */
export const optionStatusTagihan = [
  {
    value: '',
    text: 'Semua Status',
  },
  {
    value: 'PENDING',
    text: 'Belum Dibayar',
  },
  {
    value: 'PAID',
    text: 'Sudah Dibayar',
  },
]

/**
 * @description - Konfigurasi status tagihan untuk pill status
 * @returns {Object} - Object of status tagihan
 */
export const statusPillConfig = {
  PENDING: {
    text: 'Belum Dibayar',
    class: 'bg-[#FFEDED] text-[#E31A1A]',
  },
  PAID: {
    text: 'Sudah Dibayar',
    class: 'bg-[#DCF3EB] text-[#10673E]',
  },
  CANCELED: {
    text: 'Dibatalkan',
    class: 'bg-[#FFF2E2] text-[#FBA63C]',
  },
}

/**
 * @description - Konfigurasi fields untuk table tagihan
 * @returns {Array} - Array of fields
 */
export const fieldsTagihanTable = [
  {
    key: 'no',
    label: 'No',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '10px',
    },
    ...defaultClass,
  },
  {
    key: 'partner_name',
    label: 'Nama Partner',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '210px',
    },
    ...defaultClass,
  },
  {
    key: 'brand_name',
    label: 'Nama Bisnis',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '210px',
    },
    ...defaultClass,
  },
  {
    key: 'bill_type',
    label: 'Jenis Tagihan',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '180px',
    },
    ...defaultClass,
  },
  {
    key: 'period',
    label: 'Periode',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '150px',
    },
    ...defaultClass,
  },
  {
    key: 'amount',
    label: 'Nominal Tagihan',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '200px',
    },
    ...defaultClass,
    formatter: value => IDR(value),
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '180px',
    },
    ...defaultClass,
  },
  {
    key: 'no_hp',
    label: 'Kontak',
    thStyle: {
      ...defaultThStyle,
      fontSize: '12px',
      minWidth: '213px',
    },
    ...defaultClass,
  },
]
